import React, { useMemo, useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"

import moment from "moment"
import AddAutoEmail from "./AddAutoEmail"
import { deleteNow } from "helpers/delete_function"
import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import { setUpdatedData } from "helpers/data_setters"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"
import { app_url } from "app_config"

const AllAutoEmail = () => {
  const [table_data, settable_data] = useState([])

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getEmailTemplates = async () => {
      try {
        setLoading(true)
        const response = await axiosbaseurl.get("/email-template")
        if (response.data.success) {
          settable_data(response.data.data)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getEmailTemplates()
  }, [])

  return (
    <>
      {loading && <Loader />}
      <TableComponent table_data={table_data} settable_data={settable_data} />
    </>
  )
}

const TableComponent = ({ table_data, settable_data }) => {
  const [addShow, setAddShow] = useState(false)
  const [template_id, settemplate_id] = useState(null)

  const navigate = useNavigate()

  const { checkAccess, permissions } = usePermissionData()
  const module_id = 3

  const handleStatus = async (status, id) => {
    try {
      if (status) {
        const response = await axiosbaseurl.patch(
          `/email-template/${id}/status`,
          { status }
        )
        if (response.data.success) {
          settable_data(prev =>
            setUpdatedData(prev, response.data.data, "edit", "Status ")
          )
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async id => {
    try {
      const response = await axiosbaseurl.delete(`/email-template/${id}`)
      if (response.data.success)
        settable_data(prev =>
          setUpdatedData(prev, response.data.data, "delete")
        )
    } catch (error) {
      console.log(error)
      swal("", error.response.data.message || "Something went Wrong", "error")
    }
  }

  // columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        filterable: true,
        disableFilters: true,
        className: "  text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Template Name",
        accessor: "templateName",
        disableFilters: true,
        filterable: true,
        className: "col-2",
      },
      {
        Header: "Subject",
        accessor: "subject",
        disableFilters: true,
        filterable: true, 
        className: "col-3",
      },
      {
        Header: "Related To",
        accessor: "relatedTo",
        disableFilters: true,
        filterable: true, 
        Cell: cellProps => (
          <span>{cellProps.row.original.relatedTo || "--"}</span>
        ),
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        disableFilters: true,
        filterable: true,
        
        Cell: cellProps => (
          <span>
            {moment(cellProps.row.original.createdAt).format(
              "DD MMM YYYY | hh:mm A"
            )}
          </span>
        ),
      },
      {
        Header: "Status",
        disableSort: true,
        accessor: "status",
        disableFilters: true,
        filterable: true,
        className: "text-center",
        Cell: cellProps => {
          return (
            <div className="text-center">
              <select
                onChange={e =>
                  handleStatus(e.target.value, cellProps.row.original.id)
                }
                disabled={!checkAccess(module_id, "edit")}
                className={`badge fs-6 border-0 status_select_dropdown 
                                bg-${cellProps.row.original.status == "Active"
                    ? "green"
                    : "danger"
                  }`}
                value={cellProps.row.original.status}
              >
                <option value="Active">Active</option>
                <option value="InActive">InActive</option>
              </select>
            </div>
          )
        },
      },
      {
        Header: "Action",
        disableFilters: true,
        disableSort: true,
        accessor: "view",  
        Cell: cellProps => {
          return (
            <div>
              {(checkAccess(module_id, "view") ||
                checkAccess(module_id, "edit")) && (
                  <button
                    onClick={() => {
                      setAddShow(true)
                      settemplate_id(cellProps.row.original.id)
                    }}
                    className="btn btn-success bg-green btn-sm mx-2"
                  >
                    <i
                      className={`fas fa-${checkAccess(module_id, "edit") ? "pen" : "eye"
                        } `}
                    ></i>
                  </button>
                )}

              {checkAccess(module_id, "remove") && (
                <button
                  onClick={() =>
                    deleteNow(() => handleDelete(cellProps.row.original.id))
                  }
                  className="btn btn-danger btn-sm ml-10 "
                >
                  <i className="fas fa-trash-alt" title="Delete"></i>
                </button>
              )}

              {/* {checkAccess(module_id, "view") &&
                cellProps.row.original.attachment && (
                  <a
                    href={`${process.env.REACT_APP_IMAGE_PATH}/${cellProps.row.original.attachment}`}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-warning bg-warning btn-sm me-2"
                  >
                    <i className={`fas fa-paperclip `} title="Attachment"></i>
                  </a>
                )} */}
            </div>
          )
        },
      },
    ],
    [permissions]
  )

  // table data
  const data = useMemo(() => table_data, [table_data])

  return (
    <>
      <PermittedComponent isAccess={checkAccess(module_id, "view")}>
        <CommonTable columns={columns} data={data} heading={"Email Templates"}>
          <div>
            {checkAccess(module_id, "add") && (
              <button
                onClick={() => setAddShow(true)}
                className="btn btn-primary bg-blue ms-3"
              >
                <i className="fas fa-plus me-2"></i>
                Add Email Template
              </button>
            )}

            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>
        </CommonTable>

        <AddAutoEmail
          show={addShow}
          setShow={setAddShow}
          settable_data={settable_data}
          template_id={template_id}
          settemplate_id={settemplate_id}
        />
      </PermittedComponent>
    </>
  )
}

export default AllAutoEmail
